import api from './api';
import type {
  OperationSource,
  RecurrenceMode,
  RecurrenceFrequency,
  ValidationMode,
} from './search';

export interface AnalyticsFiltersPayload {
  scopes: OperationSource[];
  personalAccountIds?: string[];
  sharedAccountIds?: string[];
  expenseCategoryIds?: string[];
  expenseSubcategoryIds?: string[];
  incomeCategoryIds?: string[];
  incomeSubcategoryIds?: string[];
  operationType?: 'credit' | 'debit';
  amountMin?: number;
  amountMax?: number;
  recurring?: RecurrenceMode;
  recurrenceFrequencies?: RecurrenceFrequency[];
  validated?: ValidationMode;
  payerPartnerId?: 'partner1' | 'partner2';
  searchText?: string;
}

export interface AnalyticsPeriodInput {
  start: string;
  end: string;
  label: string;
}

export interface CategoryBreakdownItem {
  categoryId: string;
  name: string;
  isDefault: boolean;
  type: 'income' | 'expense';
  total: number;
  count: number;
}

export interface SubcategoryBreakdownItem extends CategoryBreakdownItem {
  parentCategoryId: string | null;
}

export interface AnalyticsPeriodResult {
  label: string;
  start: string;
  end: string;
  totals: { credits: number; debits: number; net: number; count: number };
  byCategory: CategoryBreakdownItem[];
  bySubcategory: SubcategoryBreakdownItem[];
}

export interface VariationItem {
  categoryId: string;
  name: string;
  type: 'income' | 'expense';
  isDefault: boolean;
  baselineTotal: number;
  comparisonTotal: number;
  deltaAbs: number;
  deltaPct: number | null;
}

export interface AnalyticsCompareResult {
  periods: AnalyticsPeriodResult[];
  variations: {
    topIncreases: VariationItem[];
    topDecreases: VariationItem[];
  };
}

export async function compareOperations(
  filters: AnalyticsFiltersPayload,
  periods: AnalyticsPeriodInput[],
): Promise<AnalyticsCompareResult> {
  const response = await api.post<{ success: boolean; data: AnalyticsCompareResult }>(
    '/analytics/compare',
    { filters, periods },
  );
  return response.data.data;
}
